<template>
  <div class="research">
    <v-container>
      <v-row class="mt-4 text-h6" justify="center">
        <v-col cols="10" xl="8">
          <div class="heading text-h4 pl-4">研究一覧</div>
        </v-col>
        <v-col cols="9" xl="7">
          <div>TMAK Lab.で行っている研究を紹介いたします。</div>
        </v-col>
      </v-row>

      <v-row class="mt-4 text-h6" justify="center">
        <v-col cols="9" xl="7">
          <div>
            <router-link to="/research/1">
              生活習慣病危険因子検出および注意喚起システムの開発 (助成:JKA)
            </router-link>
          </div>
        </v-col>
      </v-row>

      <v-row class="mt-4 text-h6" justify="center">
        <v-col cols="9" xl="7">
          <div>
            <router-link to="/research/2">
              発言集合間の類似性比較に基づく調査対象絞り込み手法に関する研究 (助成:SCAT)
            </router-link>
          </div>
        </v-col>
      </v-row>

      <v-row class="mt-4 text-h6" justify="center">
        <v-col cols="9" xl="7">
          <div>
            <router-link to="/research/3">
              異なるコミュニティにおいて誤解されやすい表現の感性的言語変換に関する研究 (助成:JSPS)
            </router-link>
          </div>
        </v-col>
      </v-row>

      <v-row class="mt-4 text-h6" justify="center">
        <v-col cols="9" xl="7">
          <div>
            <router-link to="/research/4">
              マルチモーダルAIに基づくメンタルヘルス診断におけるDX (助成:JKA)
            </router-link>
          </div>
        </v-col>
      </v-row>

      <v-row class="mt-4 text-h6" justify="center">
        <v-col cols="9" xl="7">
          <div>
            <router-link to="/research/5">
              認知機能の低下に起因する自動車事故の抑止を目的としたマルチモーダル認知症セルフチェックシステムに関する研究 (助成:日本損害保険協会 2025年度 自賠責運用益拠出事業)
            </router-link>
          </div>
        </v-col>
      </v-row>

      <v-row class="mt-4 text-h6" justify="center">
        <v-col cols="9" xl="7">
          <div>
            <router-link to="/research/6">
              共感的応答を導くメタプロンプト最適化型マルチモーダルAI (助成:科研費基盤(C)2026~2028)
            </router-link>
          </div>
        </v-col>
      </v-row>

      <v-row class="mt-4 text-h6" justify="center">
        <v-col cols="10" xl="8">
          <div class="heading text-h4 pl-4">研究室紹介</div>
        </v-col>
      </v-row>

      <v-row class="mt-4 text-h6" justify="center">
        <v-col cols="9" xl="7">
          <div>
            <router-link to="/research/description">
              研究室説明会資料
            </router-link>
          </div>
        </v-col>
      </v-row>

      <v-row class="mt-4 text-h6" justify="center">
        <v-col cols="9" xl="7">
          <div>
            <router-link to="/research/schedule">
              研究スケジュール
            </router-link>
          </div>
        </v-col>
      </v-row>

    </v-container>
  </div>
</template>

<script>
export default {
  name: "Research",
  data: () => ({}),
  methods: {},
};
</script>

<style scoped>
.heading {
  border-bottom: 2px solid #000;
}
</style>